import {
  ButtonInfo,
  ButtonStrapiComponent,
} from 'strapi/component/landingButton/types';
import { PageTypes } from 'strapi/page/types';

import { buildEditorUrlWithTemplateParams } from '../../../global/urlUtils';

export function collectButtonComponentParams(
  page: PageTypes,
  button: ButtonStrapiComponent
): ButtonInfo;
export function collectButtonComponentParams(
  page: PageTypes,
  button?: ButtonStrapiComponent | null
): ButtonInfo | undefined;

export function collectButtonComponentParams(
  page: PageTypes,
  button?: ButtonStrapiComponent | null
): ButtonInfo | undefined {
  if (!button) {
    return undefined;
  }

  let defaultUrl;

  const isUseCasePage = 'use_case' in page;
  const isSubUseCasePage = 'sub_use_case' in page;

  if (isUseCasePage) {
    defaultUrl = buildEditorUrlWithTemplateParams({
      useCase: page.use_case.slug,
    });
  }

  if (isSubUseCasePage) {
    defaultUrl = buildEditorUrlWithTemplateParams({
      useCase: page.sub_use_case.use_case.slug,
      subUseCase: page.sub_use_case.slug,
    });
  }

  return {
    url: defaultUrl || button.url,
    label: button.label,
    isSignUp: button.isSignUp,
  };
}
